import React, { useContext, useCallback } from 'react';

import { Page } from 'components';
import styled, { css } from 'styled-components';
import { useHistory } from 'react-router';
import PageHeader from './PageHeader';
import PageTabs from './PageTabs';
import DetailsTab from '../Tabs/DetailsTab';
import ListingSettingsTab from '../Tabs/ListingSettingsTab';

import TeamContext from '../../../../contexts/TeamContext';
import { TabKey } from '../types';
import MembersTab from '../Tabs/MembersTab';

const TeamViewPage = () => {
  const history = useHistory();
  const { activeTab, availableTeamStates, targetTeamState, setTargetTeamId } =
    useContext(TeamContext);

  const navigateBack = useCallback(() => {
    history.goBack();
  }, [history]);

  const bodyContentMap: Record<TabKey, JSX.Element> = {
    DETAILS: <DetailsTab navigateBack={navigateBack} />,
    MEMBERS: <MembersTab />,
    LISTING_SETTINGS: <ListingSettingsTab />,
  };

  return (
    <Page
      type={activeTab === 'MEMBERS' ? 'filled' : 'hollow'}
      headerExtra={<PageHeader navigateBack={navigateBack} />}
      headerVerticalAlign="baseline"
      headerDirection="column"
      fullTitleWidth
      subHeader={<PageTabs />}
      bodyCss={
        activeTab === 'MEMBERS'
          ? undefined
          : css`
              padding: 16px;
            `
      }
      fillScreenHeight={activeTab === 'MEMBERS'}
    >
      {activeTab === 'MEMBERS' ? (
        bodyContentMap[activeTab]
      ) : (
        <BodyPane>
          <BodyContainer>{bodyContentMap[activeTab]}</BodyContainer>
        </BodyPane>
      )}
    </Page>
  );
};

export default TeamViewPage;

const BodyPane = styled.div`
  background: white;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
`;

const BodyContainer = styled.div`
  padding: 24px;
  width: min(640px, 100%);
`;
